export { default } from './ColorKitInfo';